import * as React from 'react';
import classnames from 'classnames';

import './client-approval-entry-gallery-helper.scss';

const ClientApprovalEntryGalleryThumbnailOverlay = (selectedItem, items): React.ReactNode => {
  const currentItem = items?.find(item => selectedItem.id === item.id);

  if (!currentItem) {
    return null;
  }

  const classes = classnames(
    'client-approval-entry-gallery-overlay__thumbnail-status',
    `client-approval-entry-gallery-overlay__thumbnail-status--${currentItem.status}`
  );

  return (
    <div className={classes} />
  );
};

export default ClientApprovalEntryGalleryThumbnailOverlay;
